// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"e_Sh","wrapperDark":"e_Th","wrapperLight":"e_Uh","wrapperClosed":"e_Vh","html":"e_Wh"};